import React from 'react';
import useUtilizationPerYearTotalChart from './hooks/useUtilizationPerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const UtilizationPerYearTotal = ({ heigth = 400 }) => {
    const { series, subtitles } = useUtilizationPerYearTotalChart();

    return (
        <SimpleBars
            series={series}
            values={[]}
            subtitles={subtitles}
            title={`Soma da Utilização Mensal por Ano`}
        />
    );
};
